import React from 'react';
import '../stylesheets/homepage.css';

const Home = () => (
  <div className="homepage-component">
    <h3 className="greeting">WELCOME TO MY WORLD!</h3>
    <h1 className="hero-title">
      Hi, I&apos;m Tobin
      <br />
      <span className="homepage-profession-title">.</span>
      <br />
      <span className="hero-title-two">
        working remotely.
      </span>
    </h1>
  </div>
);

export default Home;
